export async function passwordReset(url: RequestInfo, token: string, hash: string, password: string, repeatPassword: string) {

    return await fetch(url + '/api/password-reset', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                'token': token,
                'hash': hash,
                'password': password,
                'repeat_password': repeatPassword,
            }
        )
    })
        .then(response => response.json())
        .catch(err => {
            console.log(err);
        });
}